export const SET_CUSTOMER_DETAILS_INQUIRY = "SET_CUSTOMER_DETAILS_INQUIRY";
export const IS_ADDED_A_NEW_SQAURE_UP_CARD = "IS_ADDED_A_NEW_SQAURE_UP_CARD";
